/**
 * Adds a `hydrated` class to the element when it is first updated to mitigate
 * flash of unstyled content (FOUC).
 *
 */
export default function hydratedClass() {
    return function hydrated(target) {
        // @ts-ignore
        const originalFirstUpdated = target.prototype.firstUpdated;
        Object.assign(target.prototype, {
            firstUpdated(...args) {
                originalFirstUpdated.call(this, args);
                this.classList.add("hydrated");
            },
        });
    };
}
//# sourceMappingURL=hydrated_class.js.map